import {setupTabs} from "./tabs";
import {setupTemplateTags} from "./template-tags";
import {setupTestEmails} from "./test-emails";
import {setupConditionalFields} from "./conditional-fields";
import setupSettingsForm from "./settings-form";

setupSettingsForm();
setupTabs();
setupTemplateTags();
setupConditionalFields();
setupTestEmails();
